<div class="container-fluid maap-root-container">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="row">
        <header class="standalone-page-header notification-management-page-header col-12">
            <h1 class="standalone-page-title">Announcement Management</h1>
        </header>
        <p-toast position="top-center" life="10000"></p-toast>

        <section class="col-12 notification-table-wrapper" aria-labelledby="active-announcements-heading">
            <div class="notification-table-inner">
                <h2 id="active-announcements-heading" class="announcement-table-heading">Active Announcements</h2>
                <div class="add-announcement-btn-wrapper" *ngIf="isDdpd">
                    <p-button (click)="showAnnouncementAdd()" variant="text" severity="info">Add Announcement</p-button>
                </div>
                <p-table [value]="activeRecords" [paginator]="true" [rows]="20">
                    <ng-template pTemplate="header">
                        <tr><th *ngFor="let col of cols" style="min-width: 130px;">{{ col.header }}</th></tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td *ngFor="let col of cols">
                                <ng-container [ngSwitch]="col.field">
                                    <span *ngSwitchCase="'startDate'">{{ rowData.startDate | date:'MM-dd-yyyy':'UTC' }}</span>
                                    <span *ngSwitchCase="'endDate'">{{ rowData.endDate ? (rowData.endDate | date:'MM-dd-yyyy':'UTC') : 'Open' }}</span>
                                    <span *ngSwitchCase="'Actions'">
                                        <span pTooltip="Edit Announcement" tooltipPosition="bottom">
                                            <p-button icon="pi pi-user-edit" [disabled]="!canEdit(rowData)" [styleClass]="'p-button-rounded p-button-text' + (!canEdit(rowData) ? ' announcement-action-disabled' : '')" (click)="showUpdateAnnouncement(rowData)"></p-button>
                                        </span>
                                        <span pTooltip="Archive Announcement" tooltipPosition="bottom">
                                            <p-button icon="pi pi-inbox" [disabled]="!canArchive(rowData)" [styleClass]="'p-button-rounded p-button-text' + (!canArchive(rowData) ? ' announcement-action-disabled' : '')" (click)="archiveAnnouncement(rowData)"></p-button>
                                        </span>
                                    </span>
                                    <span *ngSwitchDefault>{{ rowData[col.field] }}</span>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </section>

        <section *ngIf="isDdpd" class="col-12 notification-table-wrapper" aria-labelledby="inactive-announcements-heading">
            <div class="notification-table-inner">
                <h2 id="inactive-announcements-heading" class="announcement-table-heading">Inactive Announcements</h2>
                <p-table [value]="inactiveRecords" [paginator]="true" [rows]="20">
                    <ng-template pTemplate="header">
                        <tr><th *ngFor="let col of inactiveCols" style="min-width: 130px;">{{ col.header }}</th></tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td *ngFor="let col of inactiveCols">
                                <ng-container [ngSwitch]="col.field">
                                    <span *ngSwitchCase="'startDate'">{{ rowData.startDate | date:'MM-dd-yyyy':'UTC' }}</span>
                                    <span *ngSwitchCase="'archiveDate'">{{ rowData.archiveDate ? (rowData.archiveDate | date:'MM-dd-yyyy':'UTC') : '—' }}</span>
                                    <span *ngSwitchDefault>{{ rowData[col.field] }}</span>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </section>
    </div>
</div>

<p-dialog [header]="announcementId ? 'Edit Announcement' : 'Create Announcement'" [(visible)]="announcementAddUpdate" [focusOnShow]="false" [style]="{width: '50vw'}">
    <div class="row">
        <div class="col-md-6 announcement-date-field">
            <label for="announcement-start-date">Start Date</label>
            <p-datepicker name="startdate" [(ngModel)]="scope.startDate" inputId="announcement-start-date" [showOnFocus]="true" [autofocus]="false" showIcon iconDisplay="input" appendTo="body" />
        </div>
        <div class="col-md-6 announcement-date-field">
            <label for="announcement-end-date">End Date</label>
            <p-datepicker name="enddate" [(ngModel)]="scope.endDate" inputId="announcement-end-date" [showOnFocus]="true" [autofocus]="false" showIcon iconDisplay="input" appendTo="body" />
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <label style="display:block;">Announcement Header</label>
            <input class="form-control" type="text" [(ngModel)]="scope.notification_name" (change)="validateForm()" (keyup)="validateForm()" />
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <label style="display:block;">Description</label>
            <textarea class="form-control announcement-description" [(ngModel)]="scope.description" rows="5" (change)="validateForm()" (keyup)="validateForm()"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="form-group float-right mt-3">
            <p-button label="Cancel" (click)="announcementAddUpdate=false" variant="text" severity="info" />
            <p-button label="Submit" [disabled]="!isValid" (click)="submitAnnouncement()" variant="text" severity="info" />
        </div>
    </ng-template>
</p-dialog>
